// Mention node shape constants. The element type matches @platejs/mention's
// `KEYS.mention` ('mention'); kept here so MentionInputElement and tests
// don't sprinkle the raw string. The `@` prefix is what the chip displays
// and what the docx exporter strips/re-adds.
export const MENTION_NODE_TYPE = 'mention' as const;
export const MENTION_PREFIX = '@' as const;

export const MENTION_NO_RESULTS_TEXT = 'No people found';
